import React from 'react';
import { LoadingMode } from '../Components/LoadingMode';
import { LiaTimesSolid } from 'react-icons/lia';
import { formatAmount, formatDateStrToDate } from '../utils';

function ModalAcceptOffer({ content }) {
  const {
    clickedBidChatUser,
    isAcceptingOffer,
    handleAcceptOffer,
    getDataById,
    handleOpenandCloseModal,
  } = content;

  /* function formatDate(locale, data) {
    const date = new Date(data);
    return new Intl.DateTimeFormat(locale).format(date);
  } */

  return (
    <article className='w-full md:w-[25rem] bg-p-wh shadow rounded absolute py-8 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
      <h2 className='text-[18px] font-semibold pb-2 mb-6 px-6 border-b-hf'>
        Accept Offer
      </h2>
      <span
        className='absolute items-center  top-6 right-6 text-2xl text-s-bk cursor-pointer hover:text-p-bk'
        onClick={() => handleOpenandCloseModal('close')}
      >
        <LiaTimesSolid />
      </span>
      <div className='flex flex-row justify-between mb-6'>
        <p className='px-6 flex flex-col justify-between'>
          {/* {formatDate('en-US', `${clickedBidChatUser?.chats[0]?.created_at}`)} */}
          {formatDateStrToDate(clickedBidChatUser?.chats[0]?.created_at)}
          <span className='text-s-bk text-sm'>Bid Date</span>
        </p>

        <p className='px-6 flex flex-col justify-between'>
          {clickedBidChatUser?.unique_code}
          <span className='text-s-bk text-sm'>Transaction Id</span>
        </p>
      </div>
      <div className='bg-b-mct border-dashed border-y-hf border-s-bk mx-6'>
        <p className='px-6 flex flex-row justify-between'>
          <span className='text-s-bk text-sm'>Fx amount</span>
          {`${formatAmount(clickedBidChatUser?.chats[0]?.amount * 1)} ${
            getDataById?.quote_currency?.symbol
          }`}
        </p>
        <p className='px-6 flex flex-row justify-between'>
          <span className='text-s-bk text-sm'>Rate</span>
          {`${formatAmount(clickedBidChatUser?.chats[0]?.rate * 1)} ${
            getDataById?.base_currency?.symbol
          }`}
        </p>
        <p className='px-6 flex flex-row justify-between'>
          <span className='text-s-bk text-sm'>Transaction fee</span>
          {(getDataById?.auth_user_commission)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{" "}
            {getDataById?.base_currency?.symbol}
        </p>
        <p className='px-6 flex flex-row justify-between'>
          <span className='text-s-bk text-sm'>Total amount</span>
          {`${formatAmount(
            clickedBidChatUser?.chats[0]?.amount *
              clickedBidChatUser?.chats[0]?.rate *
              1
          )} ${getDataById?.base_currency?.symbol}`}
        </p>{' '}
      </div>
      <div className='flex flex-row gap-6 px-6 pt-8'>
        <button
          className='py-2 bg-b-mc disabled:bg-b-mct text-p-wh relative rounded-md hover:bg-b-mc/75 focus:bg-b-mc/80 text-base px-6 w-full'
          onClick={handleAcceptOffer}
          disabled={isAcceptingOffer}
        >
          Accept
          {isAcceptingOffer && <LoadingMode />}
        </button>
      </div>
    </article>
  );
}

export default ModalAcceptOffer;
